import { render, staticRenderFns } from "./SolutionDeleteModal.vue?vue&type=template&id=60c0d518&scoped=true&"
import script from "./SolutionDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./SolutionDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c0d518",
  null
  
)

export default component.exports